import LivesSaved from './LivesSaved';

export * from './types';
export default LivesSaved;
